/** Atlas use cases stay grouped so they are not mistaken for separate products. */
export const atlasUseCases = [
  {
    href: '/prospecting',
    label: 'Prospecting',
    description: 'Find active borrowers and new opportunities.',
  },
  {
    href: '/underwriting',
    label: 'Underwriting',
    description: 'Research experience, portfolios, and liabilities.',
  },
  {
    href: '/investor-tracking',
    label: 'Investor Tracking',
    description: 'Follow borrower activity and portfolio changes.',
  },
];
